import { createSlice } from '@reduxjs/toolkit';
import { _User } from 'models/user';

interface IReduxState {
  signedInUser?: _User;
}

const initialState: IReduxState = {
  signedInUser: {
    id: '',
    createdBy: '',
    updatedBy: '',
    cpf: '',
    fullName: '',
    email: '',
    cellPhone: '',
    application: '',
    status: '',
    externalId: '',
    avatar: '',
    jobTitle: '',
    coverImg: '',
    role: '',
    laboratoryId: '',
    isAdmin: false,
    location: '',
    posts: '',
    createdAt: '',
    roles: [],
  },
};

const signinSlice = createSlice({
  name: 'signin',
  initialState,
  reducers: {
    setSignedIn(state, action: { payload: _User }) {
      state.signedInUser = action.payload;
    },
  },
});

export const { setSignedIn } = signinSlice.actions;

export default signinSlice.reducer;
